import { render, staticRenderFns } from "./SGPDrawerComponent.vue?vue&type=template&id=3053cd7e"
import script from "./SGPDrawerComponent.vue?vue&type=script&lang=js"
export * from "./SGPDrawerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports